import axios from 'axios';

import {
	TIMELINE_FETCH,
	TIMELINE_CLEAR_DATA,
	TIMELINE_REQ_DATA,
	TIMELINE_RECV_INIT_DATA,
	TIMELINE_RECV_NEXT_DATA,
	TIMELINE_RECV_PREV_DATA,
	TIMELINE_RECV_ERROR,
	TIMELINE_FILTER,
	TIMELINE_FETCH_NEXT,
	TIMELINE_FETCH_PREV,
} from '../constants/actions';

import baseUrl from '../utils/baseUrl';
let isFetching = 0;

function createAction(type) {
	return { type };
}

function createResponse(json, type) {
	// console.log(type);
	return {
		type,
		payload: json,
	};
}

function createDispatch(dispatch, action, data, params) {
	if (action === TIMELINE_RECV_INIT_DATA) {
		dispatch(createResponse({
			params,
			data,
		}, action));
	} else {
		dispatch(createResponse(data, action));
	}
}

function processData(dispatch, action, url, params, data) {
	// console.log('~~ PROCESSING DATA ~~');
	if (action === TIMELINE_RECV_INIT_DATA || action === TIMELINE_RECV_PREV_DATA) {
		let skipCount = 0;
		for (let i = 0; i < data.items.length; i++) {
			if (data.items[i].hero) {
				skipCount = 0;
				break;
			}

			skipCount++;
		}

		if (skipCount >= 20 && data.prev) {
			// console.log('SKIPCOUNT IS TOO DAMN HIGH -- ' + skipCount);
			let url = data.prev;
			url = url.replace(/^.*\/\/[^\/]+/, '');
			axios.get(url)
			.then((res) => {
				const newData = { ...data };
				if (res.data && res.data.items) {
					const pageSplitter = [{
						type: 'page-indicator',
						uid: Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1),
					}];

					newData.items = res.data.items.concat(pageSplitter).concat(data.items);
					newData.prev = res.data.prev;
				}
				processData(dispatch, action, url, params, newData);
			})
			.catch((res) => {
				console.log('TIMELINE -- FAILED PULLING EXTRA DATA');
			});
		} else {
			createDispatch(dispatch, action, data, params);
		}
	} else {
		createDispatch(dispatch, action, data, params);
	}

}

export function fetchTimeline(params = {}, url = '/api/timeline/', direction = false) {
	// console.log('called fetchTimeline');
	if (isFetching) {
		// console.log('is already fetching');
		// return { type: 'NOOP' };
	}

	url = baseUrl + url;

	// strip domain from url
	url = url.replace(/^.*\/\/[^\/]+/, '');

	let action = direction ? (
		direction === TIMELINE_FETCH_NEXT ? TIMELINE_RECV_NEXT_DATA : TIMELINE_RECV_PREV_DATA
	) : TIMELINE_RECV_INIT_DATA;
	// console.log(`Fetching timeline - ACTION: ${action} - DIRECTION: ${direction}`);

	return function(dispatch) {
		let buildParams = { filter: {}};
		if (action === TIMELINE_RECV_INIT_DATA) {
			dispatch(createAction(TIMELINE_CLEAR_DATA));

			if (params && Object.keys(params).length) {
				//console.log(params);
				buildParams = {
					params: params,
				};
			}
		}

		let filtered = !!(buildParams.params && buildParams.params.filter);

		dispatch(createAction(TIMELINE_REQ_DATA));
		isFetching = true;
		return axios.get(url, buildParams)
		.then((response) => {
			processData(dispatch, action, url, buildParams, response.data);

			if (filtered) {
				window.scrollTo(0, 20);
			}

			isFetching = false;
		})
		.catch((response) => {
			dispatch(createResponse(response.data, TIMELINE_RECV_ERROR));
			isFetching = false;

			if (filtered) {
				window.scrollTo(0, 20);
			}

			console.log('timeline - fetch error');
			console.log(response);

			// dispatch(pushState(null, '/error'));
		});
	};
}

export function setFilter(filter = {}) {
	return createResponse(filter, TIMELINE_FILTER);
}



/** WEBPACK FOOTER **
 ** ./frontend/actions/timelines.js
 **/